var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key != "symbol" ? key + "" : key, value);
import { ROOT_NODE_ID } from "./constants.js";
let subscriptionCallback, rootId = ROOT_NODE_ID, globalTreeMode = "DEFAULT", search = !1;
class Node {
  constructor(id, registration, label, source, selectMapper, parent) {
    __publicField(this, "_id");
    __publicField(this, "parent");
    __publicField(this, "children", []);
    __publicField(this, "registration");
    __publicField(this, "tmt", setTimeout(() => {
    }));
    __publicField(this, "_selectMapper");
    var _a;
    id === ROOT_NODE_ID && this.resetGlobal(), this.parent = parent, this._id = id, this.registration = registration;
    const defaultRegInfo = {
      selected: void 0,
      hidden: !1,
      expanded: !1,
      parentId: parent == null ? void 0 : parent.id,
      source,
      label,
      id,
      children: [],
      level: ((_a = this.parent) == null ? void 0 : _a.level) != null ? this.parent.level + 1 : 0
    };
    this.registration[id] = {
      ...defaultRegInfo,
      ...this.registration[id]
    }, this._selectMapper = selectMapper;
  }
  get globalTreeRoot() {
    return rootId;
  }
  set globalTreeRoot(id) {
    rootId = id;
  }
  get searchMode() {
    return search;
  }
  set searchMode(enabled) {
    search = enabled;
  }
  get level() {
    return this.reg.level;
  }
  set level(lvl) {
    this.reg.level = lvl;
  }
  get id() {
    return this.registration[this._id].id;
  }
  set id(id) {
    this.registration[id].id = id, this._id = id;
  }
  get reg() {
    return this.registration[this.id];
  }
  set reg(data) {
    this.registration[this.id] = data;
  }
  set selected(selected) {
    this.reg.selected = selected;
  }
  get selected() {
    return this.reg.selected;
  }
  get expanded() {
    return this.reg.expanded;
  }
  set expanded(v) {
    this.reg.expanded = v;
  }
  set hidden(h) {
    this.reg.hidden = h;
  }
  get hidden() {
    return this.reg.hidden;
  }
  resetGlobal() {
    subscriptionCallback == null || subscriptionCallback([], void 0, void 0), subscriptionCallback = void 0, rootId = ROOT_NODE_ID, globalTreeMode = "DEFAULT", search = !1;
  }
  update(emitSelected = !0) {
    clearTimeout(this.tmt), this.tmt = setTimeout(() => {
      this.emit(emitSelected);
    });
  }
  emit(emitSelected = !0, modeOverride) {
    this.reg = { ...this.reg };
    let selected;
    emitSelected && (selected = this._selectMapper(this.registration));
    const nodesParameters = {}, mode = this.searchMode ? "DEFAULT" : modeOverride ?? globalTreeMode;
    if (mode === "DEFAULT")
      for (const { id, parentId, hidden } of Object.values(this.registration)) {
        const parentIsHiddenOrCollapsed = parentId && parentId !== ROOT_NODE_ID && (this.registration[parentId].hidden || !this.registration[parentId].expanded);
        id === ROOT_NODE_ID || hidden || parentIsHiddenOrCollapsed || (nodesParameters[id] = { ...this.registration[id] });
      }
    else {
      const rootNode = this.registration[this.globalTreeRoot];
      rootNode.id !== ROOT_NODE_ID && (nodesParameters[rootNode.id] = { ...rootNode, level: 1 });
      for (const id of rootNode.children)
        nodesParameters[id] = {
          ...this.registration[id],
          level: rootNode.id === ROOT_NODE_ID ? 1 : 2
        };
    }
    subscriptionCallback == null || subscriptionCallback(
      Object.values(nodesParameters),
      selected,
      mode === "ONLY_NODE_AND_1_LEVEL_CHILDREN" ? this.globalTreeRoot : void 0
    );
  }
  setSelection(uuids) {
    uuids.includes(this.id) && this.select({ noBubbling: !1, noUpdate: !0, noExpand: !0 }), this.children.forEach((c) => c.setSelection(uuids)), this.id === ROOT_NODE_ID && this.update();
  }
  subscribe(cb) {
    subscriptionCallback = cb;
  }
  unsubscribe() {
    this.resetGlobal();
  }
  resetSearch() {
    this.searchMode = !1;
    for (const id of Object.keys(this.registration))
      this.registration[id].hidden = !1, this.registration[id].expanded = !1;
    this.emit(!1);
  }
  find(str) {
    if (!str || str.length < 2) {
      this.resetSearch();
      return;
    }
    this.searchMode = !0, this.globalTreeRoot = ROOT_NODE_ID;
    for (const nodeInfo of Object.values(this.registration))
      if (nodeInfo.hidden = !0, nodeInfo.expanded = !1, nodeInfo.label.toLowerCase().includes(str.toLowerCase())) {
        nodeInfo.hidden = !1;
        let parent = nodeInfo.parentId ? this.registration[nodeInfo.parentId] : void 0;
        for (; parent && (!parent.expanded || parent.hidden); )
          parent.expanded = !0, parent.hidden = !1, parent = parent.parentId ? this.registration[parent.parentId] : void 0;
      }
    this.registration[ROOT_NODE_ID].hidden = !1, this.registration[ROOT_NODE_ID].expanded = !0, this.emit(!1, "DEFAULT");
  }
  setGlobalTreeMode(m) {
    m !== globalTreeMode && (globalTreeMode = m, this.globalTreeRoot = ROOT_NODE_ID, this.resetSearch(), this.emit());
  }
  expand(showChildren = !1) {
    if (this.reg.children) {
      for (const id of this.reg.children)
        this.registration[id].expanded = !1;
      globalTreeMode === "DEFAULT" ? this._expand(showChildren) : (this.globalTreeRoot = this.id, this._expand(showChildren)), this.update(!1);
    }
  }
  _expand(showChildren = !1) {
    var _a;
    (!this.expanded || this.hidden) && (this.expanded = !0, this.hidden = !1), showChildren && this.children.forEach((c) => c.show()), (_a = this.parent) == null || _a._expand();
  }
  show() {
    this.hidden = !1, this.update(!1);
  }
  collapse() {
    if (this.reg.children)
      if (globalTreeMode === "DEFAULT")
        this._collapse(), this.emit(!1);
      else {
        const parent = this.reg.parentId ? this.registration[this.reg.parentId] : null;
        parent && (this.globalTreeRoot = parent.id), this._collapse(), this.emit(!1);
      }
  }
  _collapse() {
    this.expanded = !1, this.children.length && this.children.forEach((c) => {
      c._collapse(), c.hidden = !0;
    });
  }
  select({
    noBubbling,
    noUpdate,
    noExpand
  } = {}) {
    var _a;
    this.selected = "selected";
    for (const child of this.children)
      child.select({ noBubbling: !0, noUpdate: !0 });
    noBubbling || (_a = this.parent) == null || _a.childSelected(noExpand), noUpdate || this.emit();
  }
  deselect(noBubbling, noUpdate) {
    var _a;
    this.selected = void 0;
    for (const child of this.children)
      child.deselect(!0, !0);
    noBubbling || (_a = this.parent) == null || _a.childDeselected(), noUpdate || this.emit();
  }
  childDeselected() {
    var _a;
    this.children.some((n) => n.selected) ? this.selected = "indeterminate" : this.selected = void 0, (_a = this.parent) == null || _a.childDeselected();
  }
  childSelected(noExpand) {
    var _a;
    const allChildrenSelected = this.children.every(
      (n) => n.selected === "selected"
    );
    this.selected = "indeterminate", noExpand || (this.expanded = !0), allChildrenSelected && (this.selected = "selected"), (_a = this.parent) == null || _a.childSelected(noExpand);
  }
  spawn(id, label, source) {
    const newNode = new Node(
      id,
      this.registration,
      label,
      source,
      this._selectMapper,
      this
    );
    return this.children.push(newNode), this.reg.children.push(id), newNode;
  }
}
export {
  Node
};
//# sourceMappingURL=Node.js.map
